// extracted by mini-css-extract-plugin
export default {"sliderIcon":"FormSection_sliderIcon__JojvS"};